import app, { Component } from 'apprun';
import { lookup_en } from '../utils';

export default class CommonPropertyComponent extends Component {
  state = { selectOptions: [] };

  view = (state) => {
    if (!state.caller) {return;}
    const prov = state.caller.state.location.locationDetail.find(e => e.fieldName === 'ProvStateCt').value.toString();

    if (prov === '') {
      state.selectOptions = state.selectOptions.filter(a => a.id === 0);
    } else {
      state.selectOptions = state.selectOptions.filter(
        a => a.id === 0 || a.value.substr(a.value.indexOf('-') + 1, a.value.length - 1) === prov
      );
    }

    return (
      <form class="form-horizontal" style={{ width: '450px' }}>
        <div class="row">
          <div class="col-sm-12">{state.item.dispName}</div>
          {
            <div class="col-sm-12">
              <select id="inpText" class="form-control" oninput={e => (state.newVal = e.target.value)}>
                {state.selectOptions.map(p => (
                  <option
                    value={p.id}
                    selected={
                      p.id.toString().toUpperCase() === (state.newVal ? state.newVal : '').toString().toUpperCase()
                        ? 'selected'
                        : null
                    }>
                    {p.value.substr(0, p.value.indexOf('-'))}
                  </option>
                ))}
              </select>
            </div>
          }
        </div>
        <div id="inpTextErrMsg" class="text-danger"></div>
        <div class="edit-buttons">
          <a
            type="button"
            class="btn btn-primary btn-xs"
            style={
              state.item.required || state.item.value === ''
                ? { display: 'none' }
                : { display: 'inline-block' }
            }
            onclick={() => state.caller.run(state.delete, state.item, state.panelId)}>
            delete
          </a>
          <a type="button" class="btn btn-primary btn-xs" onclick={() => this.run('save')}>
            save
          </a>
          <a
            type="button"
            class="btn btn-default btn-xs"
            onclick={() => state.caller.run(state.cancel, state.panelId)}>
            cancel
          </a>
        </div>
      </form>
    );
  };

  update = {
    refresh: (state, newState) => {
      state = newState;
      let selectOptions = [];
      if (state.item.fieldTypeDetail && state.item.fieldTypeDetail.startsWith('[')) {
        selectOptions = JSON.parse(state.item.fieldTypeDetail);
      } else {
        selectOptions = lookup_en[state.item.fieldTypeDetail];
      }
      selectOptions = selectOptions || [];

      return { ...state, selectOptions, newVal: newState.item.value };
    },

    save: (state) => {
      if (!state.newVal) {return;}
      state.caller.run(state.save, state.item, state.panelId, state.newVal);
    },
  };

  mounted = ({ state }) => {
    this.run('refresh', state);
  };
}
